import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { selectDetail } from 'store/Contextualization/AssetDetail/selectors';
import { updateVulnFromAsset } from 'store/Contextualization/AssetDetail/actions';
import MarkdownEditor from 'Common/Components/v2/MarkdownEditor';
import ExpandableWrapper from '../ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const TAB = 'general';
const ID = 'resolution';

const Resolution = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentVuln = useSelector((state) => selectDetail('vulns', state));
  const resolution = get(currentVuln, 'resolution', '');
  const updateValue = (field, value) => dispatch(updateVulnFromAsset(currentVuln, field, value));
  const isExpanded = useExpandable(TAB, ID, resolution, currentVuln?._id);

  const readOnly = useSelector(selectIsReadOnly);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const disabled = readOnly || !canUpdate;

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="resolution" title={ intl.formatMessage({ id: 'manage.detail.tab.general.resolution' }) } tab={ TAB }>
      <MarkdownEditor
        value={ resolution }
        onBlur={ (value) => updateValue('resolution', value) }
        disabled={ disabled }
        minHeight={ 170 }
      />
    </ExpandableWrapper>
  );
};

export default Resolution;
